module.exports = __webpack_public_path__ + "img/ic-level-advance.a12ed352.svg";